import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=da9fae7e&scoped=true"
import script from "./ChatRoom.vue?vue&type=script&lang=js"
export * from "./ChatRoom.vue?vue&type=script&lang=js"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&id=da9fae7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9fae7e",
  null
  
)

export default component.exports